var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsInt, IsNotEmpty, IsOptional, IsString, IsTimeZone, Matches, Min, } from 'class-validator';
class PermissionFlags {
    admin;
    send_pulse;
    audience;
    invite_link;
}
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Object)
], PermissionFlags.prototype, "admin", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Object)
], PermissionFlags.prototype, "send_pulse", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Object)
], PermissionFlags.prototype, "audience", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Object)
], PermissionFlags.prototype, "invite_link", void 0);
export class PermissionParamsDto {
    advertiser_account_id;
    user_id;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], PermissionParamsDto.prototype, "advertiser_account_id", void 0);
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], PermissionParamsDto.prototype, "user_id", void 0);
export class UpdatePermissionInputDto extends PermissionFlags {
    comment;
    time;
    gmt;
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdatePermissionInputDto.prototype, "comment", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty(),
    Matches(/\d{1,2}:\d{2}/),
    __metadata("design:type", Object)
], UpdatePermissionInputDto.prototype, "time", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty(),
    IsTimeZone(),
    __metadata("design:type", Object)
], UpdatePermissionInputDto.prototype, "gmt", void 0);
export class CreateInviteInputDto extends PermissionFlags {
    one_time;
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateInviteInputDto.prototype, "one_time", void 0);
//# sourceMappingURL=user.js.map